import React from 'react'
import Spinner from '../../../../components/common/loader/Loader'
import DashboardDataTable from './DashboardDataTable'
import './DashboardDataSetup.less'
import { SurveysPane } from '../../data-setup/SurveysPane'
import { ResourcesPane } from '../../data-setup/ResourcesPane'
import { EventsPane } from '../../data-setup/EventsPane'
import { WorkspacesPane } from '../../data-setup/WorkspacesPane'
import { PathwaysPane } from '../../data-setup/PathwaysPane'
import { CampaignsPane } from '../../data-setup/CampaignsPane'
import { GetDashboardQuery } from '../ManageDashboardPage.codegen'

interface IProps {
  dashboardId: number
  dashboardData: NonNullable<GetDashboardQuery['admin']>['dashboard']
}

export const DashboardDataSetup = ({ dashboardId, dashboardData }: IProps) => {
  if (!dashboardData) {
    return <Spinner />
  }

  return (
    <div className="DataTableGrid">
      <div className="DataTableGrid__items">
        <DashboardDataTable>
          <SurveysPane
            dashboardId={dashboardId}
            items={dashboardData.surveys || []}
          />
        </DashboardDataTable>
        <DashboardDataTable>
          <ResourcesPane
            dashboardId={dashboardId}
            items={dashboardData.topics || []}
          />
        </DashboardDataTable>
        <DashboardDataTable>
          <EventsPane
            dashboardId={dashboardId}
            items={dashboardData.events || []}
          />
        </DashboardDataTable>
        <DashboardDataTable>
          <WorkspacesPane
            dashboardId={dashboardId}
            items={dashboardData.workspaces || []}
          />
        </DashboardDataTable>
        <DashboardDataTable>
          <PathwaysPane
            dashboardId={dashboardId}
            items={dashboardData.pathways || []}
          />
        </DashboardDataTable>
        <DashboardDataTable>
          <CampaignsPane
            dashboardId={dashboardId}
            items={dashboardData.campaigns || []}
          />
        </DashboardDataTable>
      </div>
    </div>
  )
}
